'use client'

import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMemo } from 'react'

import { useLocale } from '~/hooks/use-locale.hook'
import { getConcatDaysHours } from './get-concat-days-hours'

export type { OpeningHour } from './get-concat-days-hours'
export { getConcatDaysHours } from './get-concat-days-hours'

export const useSpaceHours = (hours?: Space['hours']) => {
	const locale = useLocale()
	const spaceHours = useMemo(
		() => getConcatDaysHours(hours, locale),
		[hours, locale],
	)

	return {
		spaceHours,
	}
}
